import React from 'react';
import {NavLink} from 'react-router-dom';
import {IStyleguideRoute} from '../../types/types';
import {useTranslation} from 'react-i18next';

/**
 * Свойства компонента.
 *
 * @prop {string} label Лэйбл.
 * @prop {string} path Роут куда перебросит при нажатии на пункт меню.
 * @prop {IStyleguideRoute[]} children Массив пунктов, которые являются подменю.
 */
interface IMenuListLinkProps {
    label: string;
    path: string;
    children?: IStyleguideRoute[];
}

/**
 * Ссылка пункта меню.
 */
const MenuListLink: React.FC<IMenuListLinkProps> = ({label, path}) => {
    const {i18n} = useTranslation();

    const handleClick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    
    return (
        <NavLink
            to={(location: any) => '/' + i18n.language + '/' + path + location.search}
            className="menu-list-link"
            activeClassName="selected"
            isActive={(match) => Boolean(match)}
            onClick={handleClick}
        >
            <span>{label}</span>
        </NavLink>
    );
};

export default MenuListLink;